<template>
  <div>
    <v-card tile>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-chip label color="transparent" text-color="black">
                <h3>Nuevo Consumo</h3>
              </v-chip>
            </v-col>
          </v-row>

          <!-- Toggle modo producto -->
          <!-- <v-row class="mt-0 mb-1">
            <v-col cols="12">
              <v-switch
                v-model="modoProducto"
                label="Cargar producto del catálogo"
                inset
                dense
                hide-details
                color="primary"
              ></v-switch>
            </v-col>
          </v-row> -->

          <!-- Bloque modo producto -->
          <v-row v-show="modoProducto" class="mt-2">
            <v-col cols="12">
              <v-alert v-if="errorCargaProductos" type="error" dense>
                No se pudo cargar el catálogo de productos. Intente nuevamente.
              </v-alert>
              <v-autocomplete
                v-model="productoSeleccionado"
                :items="catalogoProductos"
                :loading="cargandoProductos"
                item-text="nombre"
                item-value="idProducto"
                return-object
                prepend-icon="mdi-package-variant"
                label="Producto *"
                dense
                clearable
                no-data-text="No hay productos activos disponibles"
                :filter="
                  (item, queryText) =>
                    item.nombre
                      .toLowerCase()
                      .includes(queryText.toLowerCase()) ||
                    (item.codigo &&
                      item.codigo
                        .toLowerCase()
                        .includes(queryText.toLowerCase()))
                "
              >
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title>{{ item.nombre }}</v-list-item-title>
                    <v-list-item-subtitle v-if="item.codigo"
                      >Código: {{ item.codigo }}</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="3">
              <v-text-field
                v-model.number="cantidad"
                prepend-icon="mdi-counter"
                label="Cantidad *"
                type="number"
                min="1"
                dense
                @keypress="onlyNumber"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="3">
              <v-text-field
                v-model="precioUnitario"
                prepend-icon="mdi-currency-usd"
                label="Precio unitario *"
                dense
                @keypress="onlyNumber"
                @blur="toFixedPrecio"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="3">
              <v-text-field
                :value="totalCalculado"
                prepend-icon="mdi-calculator"
                label="Total"
                dense
                disabled
                prefix="$"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="mt-2">
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="fechaConsumo"
                :value="fechaConsumo"
                label="Fecha Consumo *"
                :rules="requiredRules"
                prepend-icon="mdi-calendar"
                type="date"
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            :disabled="
              !valid ||
              (modoProducto && (!productoSeleccionado || cantidad <= 0))
            "
            @click.stop="guardarConsumo"
            >Guardar</v-btn
          >
        </v-card-actions>
      </v-form>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" style="margin-top: 3px">
            <v-chip class="ma-0" label color="transparent" text-color="black">
              <h3>Consumos ya realizados para este turno</h3>
            </v-chip>
          </v-col>
        </v-row>

        <v-data-table
          v-if="listaConsumos.length"
          :headers="headers"
          :items="listaConsumos"
          class="elevation-1"
          :hide-default-footer="true"
          locale="es-ar"
          item-key="idConsumo"
          :items-per-page="10000"
          ref="myTable"
          :disable-sort="true"
        >
          <template v-slot:item.descripcion="{ item }">
            <span v-if="item.idProducto && item.cantidad">
              {{ item.descripcion }} — {{ item.cantidad }} x ${{
                (item.total / item.cantidad).toFixed(2)
              }}
              = {{ item.totalString }}
            </span>
            <span v-else>{{ item.descripcion }}</span>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  medium
                  color="purple"
                  class="mr-3"
                  v-on="on"
                  v-bind="attrs"
                  @click.stop="editarConsumo(item)"
                  >mdi-pencil</v-icon
                >
              </template>
              <span>Editar consumo</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  medium
                  v-on="on"
                  class="mr-3"
                  color="red"
                  v-bind="attrs"
                  @click="borrarConsumo(item)"
                  >mdi-delete</v-icon
                >
              </template>
              <span>Eliminar consumo</span>
            </v-tooltip>
          </template>
        </v-data-table>
        <v-alert class="mt-4" color="purple" dark outlined v-else>
          No hay consumos realizados para este turno.
        </v-alert>
        <v-row v-if="listaConsumos.length" class="mt-2">
          <v-col cols="12">
            <v-btn color="primary" @click="exportarPDFNuevo">
              <v-icon left>mdi-file-pdf-box</v-icon>
              Exportar a PDF
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>

      <EditarConsumo
        :visible="showEditarConsumo"
        :idConsumo="editedItem.idConsumo"
        @close="cierraEditarConsumo($event)"
      ></EditarConsumo>
    </v-card>
  </div>
</template>
<script>
import moment from "moment";
import axios from "@/axios-auth";
import EditarConsumo from "./EditarConsumo.vue";
import jsPDF from "jspdf";
import "jspdf-autotable";

export default {
  props: {
    idTurno: {
      required: false,
      default: 0,
    },
    nombrePaciente: {
      type: String,
      required: false,
      default: "",
    },
  },
  components: {
    EditarConsumo,
  },
  data() {
    return {
      valid: false,
      lazy: false,
      fechaConsumo: null,
      descripcion: "",
      total: null,
      requiredRules: [(v) => !!v || "Dato obligatorio"],
      totalRules: [
        (v) => !!v || "Dato obligatorio",
        (v) => v > 0 || "El total debe ser mayor a 0",
      ],
      listaConsumos: [],
      headers: [
        { text: "Fecha", value: "fechaString" },
        { text: "Descripción", value: "descripcion" },
        { text: "Importe", value: "totalString" },
        { text: "Acciones", value: "actions" },
      ],
      showEditarConsumo: false,
      editedItem: {},
      cobrosExpandidos: {},
      expandedItems: [],
      headersTorneo: [
        { text: "Fecha", value: "fechaString" },
        { text: "Descripción", value: "descripcion" },
        { text: "Total Consumo", value: "totalString" },
        { text: "Total Pagado", value: "totalPagadoString" },
        { text: "Saldo", value: "saldoString" },
        { text: "Acciones", value: "actions" },
      ],
      // Modo producto
      modoProducto: true,
      productoSeleccionado: null,
      catalogoProductos: [],
      cargandoProductos: false,
      errorCargaProductos: false,
      cantidad: 1,
      precioUnitario: null,
    };
  },
  computed: {
    totalCalculado() {
      if (
        !this.cantidad ||
        this.precioUnitario === null ||
        this.precioUnitario === undefined
      )
        return 0;
      const c = parseFloat(this.cantidad);
      const p = parseFloat(this.precioUnitario);
      if (isNaN(c) || isNaN(p)) return 0;
      return parseFloat((c * p).toFixed(2));
    },
  },
  watch: {
    modoProducto(val) {
      if (val) {
        this.descripcion = "";
        this.total = null;
        if (!this.catalogoProductos.length) {
          this.cargarProductos();
        }
      } else {
        this.productoSeleccionado = null;
        this.cantidad = 1;
        this.precioUnitario = null;
      }
    },
    productoSeleccionado(producto) {
      if (producto) {
        this.precioUnitario = producto.precioVenta;
      }
    },
  },
  methods: {
    editarConsumo(item) {
      this.editedItem.idConsumo = item.idConsumo;
      this.showEditarConsumo = true;
    },
    calcularTotalPagado(idConsumo) {
      const cobros = this.cobrosExpandidos[idConsumo] || [];
      return cobros
        .filter((c) => c.estado !== "Cancelado")
        .reduce((acc, c) => acc + c.total, 0);
    },
    cierraEditarConsumo() {
      if (this.idTurno > 0) {
        this.buscarConsumosTurno();
      }
      this.showEditarConsumo = false;
    },
    toFixed() {
      if (isNaN(parseFloat(this.total)))
        this.total = parseFloat(0.0).toFixed(2);
      else this.total = parseFloat(this.total).toFixed(2);
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode != 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    vaciarModels() {
      this.descripcion = "";
      this.total = "";
      this.fechaConsumo = moment().format("YYYY-MM-DD");
      // Resetear modo producto
      this.modoProducto = true;
      this.productoSeleccionado = null;
      this.cantidad = 1;
      this.precioUnitario = null;
      this.errorCargaProductos = false;
    },
    async cargarProductos() {
      this.cargandoProductos = true;
      this.errorCargaProductos = false;
      try {
        const { data } = await axios.get("/Producto/GetProductos", {
          params: {
            idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
            estado: "Activo",
            nombre: "%",
            codigo: "%",
            idCategoria: 0,
          },
        });
        this.catalogoProductos = data || [];
      } catch {
        this.errorCargaProductos = true;
        this.catalogoProductos = [];
      } finally {
        this.cargandoProductos = false;
      }
    },
    toFixedPrecio() {
      if (isNaN(parseFloat(this.precioUnitario)))
        this.precioUnitario = parseFloat(0.0).toFixed(2);
      else this.precioUnitario = parseFloat(this.precioUnitario).toFixed(2);
    },
    guardarConsumo() {
      if (moment(this.fechaConsumo).isBefore(moment("1900-01-01"))) {
        this.showAlert({
          icon: "warning",
          title: "La fecha del consumo debe ser mayor o igual al 01/01/1900.",
          timer: 2500,
          vm: this,
        });
        return;
      }
      this.$swal({
        title: "Registrar consumo",
        text: "¿Desea registrar el consumo?",
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          const datosConsumo = {
            fecha: this.fechaConsumo,
            idTurno: this.idTurno,
            total: this.modoProducto ? this.totalCalculado : this.total,
            descripcion: this.modoProducto
              ? this.productoSeleccionado.nombre
              : this.descripcion,
            idProducto: this.modoProducto
              ? this.productoSeleccionado.idProducto
              : null,
            cantidad: this.modoProducto ? this.cantidad : null,
            usuario: this.$store.state.usuario.usuario,
            idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
          };
          let self = this;
          axios
            .post("/Caja/GuardarConsumo", datosConsumo)
            .then((response) => {
              self.$refs.form.resetValidation();
              self.vaciarModels();
              self.buscarConsumosTurno();
              document.getElementsByClassName(
                "v-dialog--active",
              )[0].scrollTop = 0;
              self.showAlert({
                icon: "success",
                title: "Consumo registrado.",
                vm: self,
                timer: 2000,
              });
              // Advertencia de stock bajo
              if (response.data && response.data.stockBajo) {
                self.showAlert({
                  icon: "warning",
                  title: `Stock bajo: el producto "${datosConsumo.descripcion}" alcanzó o superó el mínimo configurado.`,
                  vm: self,
                  timer: 4000,
                });
              }
            })
            .catch((error) => {
              self.showAlert({
                icon: "warning",
                title: "El consumo no pudo ser registrado.",
                vm: this,
                timer: 2000,
              });
            });
        }
      });
    },
    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: alertInfo.timer,
      });
    },
    buscarConsumosTurno() {
      const filtrosData = {
        idTurno: this.idTurno,
      };

      let self = this;
      axios
        .get("/Caja/BuscarConsumosTurno?", {
          params: {
            idTurno: filtrosData.idTurno,
          },
        })
        .then(function (response) {
          if (response.data != null && response.data != "")
            self.listaConsumos = response.data;
          else self.listaConsumos = [];
        })
        .catch(function (error) {
          self.listaConsumos = [];
        })
        .finally(async () => {
          const total = self.listaConsumos.reduce(
            (acc, curr) => (acc = acc + curr.total),
            0,
          );
          self.$emit("actualizarTotal", total);
        });
    },
    borrarConsumo(item) {
      this.$swal({
        title: "Borrar consumo",
        text: "¿Desea borrar el consumo?",
        icon: "success",
        background: "#ececec",
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          let self = this;
          axios
            .get("/Caja/BorrarConsumo?", {
              params: {
                idConsumo: item.idConsumo,
              },
            })
            .then((response) => {
              self.showAlert({
                icon: "success",
                title: "Consumo borrado.",
                vm: self,
                timer: 2000,
              });
              if (self.idTurno > 0) {
                setTimeout(self.buscarConsumosTurno(), 1700);
              }
              this.delta = true;
            })
            .catch((error) => {
              self.showAlert({
                icon: "warning",
                title: "El consumo no pudo ser borrado.",
                vm: this,
              });
            });
        } else {
          //this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      });
    },
    exportarPDFNuevo() {
      const doc = new jsPDF();
      const pageWidth = doc.internal.pageSize.getWidth();

      const nombreInstitucion =
        this.$store.state.usuario.institucion.nombreInstitucion
          .toString()
          .trim();
      doc.setFontSize(12);
      doc.text(nombreInstitucion, 14, 15);

      doc.setFontSize(16);
      doc.text("Reporte de Consumos", pageWidth / 2, 25, { align: "center" });

      doc.setFontSize(10);
      let y = 35;
      doc.text(
        `Fecha de emision: ${moment().format("DD/MM/YYYY HH:mm")}`,
        14,
        y,
      );
      y += 6;

      if (this.nombrePaciente) {
        doc.text(`Paciente: ${this.nombrePaciente}`, 14, y);
        y += 6;
      }

      const tableData = this.listaConsumos.map((item, index) => [
        index + 1,
        item.fechaString,
        item.descripcion || "-",
        item.totalString,
      ]);

      doc.autoTable({
        startY: y + 4,
        head: [["N", "Fecha", "Descripcion", "Importe"]],
        body: tableData,
        theme: "grid",
        headStyles: {
          fillColor: [103, 58, 183],
          textColor: 255,
          fontStyle: "bold",
        },
        styles: { fontSize: 9 },
        columnStyles: {
          0: { cellWidth: 15, halign: "center" },
          1: { cellWidth: 30, halign: "center" },
          2: { cellWidth: 100 },
          3: { cellWidth: 35, halign: "right" },
        },
      });

      const total = this.listaConsumos.reduce(
        (acc, curr) => acc + curr.total,
        0,
      );
      let finalY = doc.lastAutoTable.finalY + 8;

      doc.setFontSize(11);
      doc.setFont(undefined, "bold");
      doc.text(
        `Total consumido: $${total.toFixed(2)}`,
        pageWidth - 14,
        finalY,
        { align: "right" },
      );

      const cant = parseInt(this.cantJugadores) || 1;
      if (cant > 1) {
        finalY += 7;
        doc.text(
          `Total por jugador (${cant}): $${(total / cant).toFixed(2)}`,
          pageWidth - 14,
          finalY,
          { align: "right" },
        );
      }

      if (this.listaCobros && this.listaCobros.length > 0) {
        finalY += 12;
        doc.setFontSize(13);
        doc.setFont(undefined, "bold");
        doc.text("Cobros realizados", 14, finalY);

        const cobrosData = this.listaCobros.map((item, index) => [
          index + 1,
          item.fechaString,
          item.paciente || "-",
          item.nombreFormaPago || "-",
          item.estado || "-",
          item.totalString,
        ]);

        doc.autoTable({
          startY: finalY + 4,
          head: [["N", "Fecha", "Concepto", "Forma Pago", "Estado", "Importe"]],
          body: cobrosData,
          theme: "grid",
          headStyles: {
            fillColor: [33, 150, 243],
            textColor: 255,
            fontStyle: "bold",
          },
          styles: { fontSize: 9 },
          columnStyles: {
            0: { cellWidth: 12, halign: "center" },
            1: { cellWidth: 28, halign: "center" },
            2: { cellWidth: 55 },
            3: { cellWidth: 35 },
            4: { cellWidth: 30 },
            5: { cellWidth: 28, halign: "right" },
          },
        });
      }

      window.open(doc.output("bloburl"), "_blank");
    },
  },
  created() {
    this.fechaConsumo = moment().format("YYYY-MM-DD");
    this.buscarConsumosTurno();
    this.cargarProductos();
  },
};
</script>
